import { analyticsReport } from "@dataseat-dsp-client/lib-reporter";

export const SPLIT_BY_APP_BUNDLE_ROWS_LIMIT =
  analyticsReport.SPLIT_BY_APP_BUNDLE_ROWS_LIMIT;
export const ANALYTICS_REPORT_ROWS_LIMIT =
  analyticsReport.ANALYTICS_REPORT_ROWS_LIMIT;

export const getQuery = analyticsReport.getQuery;
